export const getAuthUrl = () => {
  // update this to use the environment variable
  const authUrl = process.env.REACT_APP_AUTH_URL || "";
  console.log("authUrl", authUrl);
  return authUrl;
};
